/**
 * ЕДИНСТВЕННЫЙ источник правды по токенам.
 * Значения — из docs/product/spec/01_design_system.md.
 *
 * После правки запустить: yarn tokens
 * Файлы в ./generated перезаписываются, руками их не трогаем.
 */

/** Цвета, тени, градиенты, свечения. Всё, что может меняться от темы. */
export const colorTokens = {
  // Поверхности
  'color-bg': '#171232',
  'color-bg-deep': '#100d24',
  'color-surface': '#352e66',
  'color-surface-alt': 'rgba(255, 255, 255, 0.1)',
  'color-surface-soft': 'rgba(255, 255, 255, 0.06)',
  // Непрозрачный эквивалент `surface-alt` поверх `bg` — фон неактивной кнопки. Сам
  // `surface-alt` полупрозрачный, и сквозь отключённую кнопку читался контент под ней;
  // «серая» кнопка должна выглядеть плотной, а не выцветшей дыркой.
  'color-control-disabled': '#2e2a46',
  // Стеклянная карточка поверх полотна — тот же surface, но полупрозрачный (макет
  // «Узы - полотно.dc.html», карточка совета). Не путать с color-overlay: тот затемняет фон.
  'color-surface-blur': 'rgba(53, 46, 102, 0.85)',
  'color-divider': 'rgba(255, 255, 255, 0.14)',
  'color-overlay': 'rgba(10, 9, 22, 0.55)',
  'color-overlay-strong': 'rgba(10, 9, 22, 0.6)',

  // Текст
  'color-text': '#fdfaf5',
  'color-text-strong': '#fffdfa',
  'color-text-secondary': '#c5bfe0',
  'color-text-muted': '#9f98c0',
  'color-text-dim': '#7d769b',
  'color-text-on-accent': '#3d1520',
  'color-text-on-surface-alt': '#e6e2f2',

  // Акцент
  'color-accent': '#ffd79b',
  'color-accent-deep': '#f0b478',
  'color-accent-soft': '#fccc90',
  'color-accent-wash': 'rgba(255, 215, 155, 0.16)',
  'color-accent-wash-strong': 'rgba(252, 204, 144, 0.18)',
  // Тонкая тёплая обводка «главного» блока экрана — хиро совместимости и карточка колеса.
  // Обе стоят на `bg-deep` и без неё сливались с фоном, а наружное свечение им не подходит:
  // обе — первый элемент скролл-контейнера, всё выше его границы обрезается.
  'color-border-accent-soft': 'rgba(255, 215, 155, 0.22)',

  // Статусы
  'color-success': '#7fd0a4',
  'color-success-wash': 'rgba(127, 208, 164, 0.16)',
  'color-success-deep': '#24483b',
  'color-error': '#f08a7a',
  'color-error-wash': 'rgba(240, 138, 122, 0.16)',
  'color-error-wash-strong': 'rgba(240, 138, 122, 0.2)',
  'color-error-text': '#f0a89b',

  // Подложки уведомлений. Уведомление всплывает поверх контента, поэтому фон обязан быть
  // непрозрачным (сквозь полупрозрачный просвечивал текст страницы) и своим на каждый вид.
  //
  // Задаются готовым цветом, а НЕ полупрозрачным тоном поверх тёмной базы. Слоёный вариант
  // (тон над `bg-deep`) давал грязь: база забирает насыщенность себе, синий канал `bg-deep`
  // тянет любой тон в фиолетовый, и все четыре вида садились в одну узкую полосу светлоты —
  // ошибка rgb(102,70,107), предупреждение rgb(97,83,114), «к сведению» rgb(73,67,117).
  //
  // Семейство собрано от карточки продукта: одна насыщенность и светлота на все четыре
  // (hsl S 27%, L 28% — рядом с `surface` #352e66, потому что уведомление лежит слоем ПОВЕРХ
  // карточек и обязано остаться карточкой, а не плашкой статуса), меняется только тон.
  // Отличаются виды тоном, а не мутностью, поэтому ни один не читается «выцветшим».
  // Ход из макета «Главная - дизайн-система.dc.html» §1, где у ошибки прямо указана
  // собственная поверхность тоста #4a2531, а не заливка *-wash.
  //
  // Тона: ошибка уведена в винный (350°, а не коралловые 8°) — рядом с тёплым золотом
  // предупреждения два соседних тёплых тона снова слипались бы; предупреждение — бронза
  // 32° по тону `accent-deep`, а не 38°, иначе подложка уходила в хаки.
  'color-notification-error': '#5c3444',
  'color-notification-warning': '#5c4a34',
  'color-notification-success': '#2f5145',
  'color-notification-info': '#3a3560',

  // Подложка комплимента, летящего по нити: кремовая со светлой заливкой и тёмным текстом —
  // ощущение бумажной записки. Выбрана из шести вариантов, разложенных по разным лучикам
  // одновременно (розовый, лавандовый, мятный, персиковый, небесный, кремовый).
  'color-compliment': '#f5ece0',
  'color-compliment-text': '#3f3325',

  // Фоновые пятна
  'color-glow-violet': 'rgba(115, 95, 185, 1)',
  'color-glow-warm': 'rgba(222, 152, 112, 1)',

  // Градиенты
  'gradient-accent': 'linear-gradient(160deg, #ffd79b, #f0b478)',
  'gradient-header-scrim': 'linear-gradient(180deg, rgba(23, 18, 50, 0.9), transparent)',

  // Свечения звёзд
  'glow-me': '0 0 0 7px rgba(252, 204, 144, 0.12), 0 0 54px 14px rgba(252, 204, 144, 0.34)',
  'glow-near': '0 0 34px 9px rgba(255, 215, 155, 0.3)',
  'glow-mid': '0 0 24px 6px rgba(255, 215, 155, 0.16)',
  'glow-far': '0 0 18px 5px rgba(255, 215, 155, 0.1)',
  'glow-beacon': '0 0 26px 8px rgba(240, 138, 122, 0.22)',
  'glow-shine': '0 0 40px 6px rgba(255, 215, 155, 0.16)',

  // Тени
  'shadow-card': '0 16px 34px rgba(0, 0, 0, 0.5)',
  // Верхняя линия у меню-острова должна лишь отделять его от подъезжающей карточки,
  // а не читаться как чёрная обводка — поэтому мягкая и полупрозрачная, а не 0-радиусная.
  'shadow-menu': '0 -1px 12px rgba(10, 9, 22, 0.45), 0 14px 38px rgba(0, 0, 0, 0.55)',
  'shadow-sheet': '0 -16px 50px rgba(0, 0, 0, 0.55)',
  'shadow-compliment': '0 10px 28px rgba(245, 236, 224, 0.32)',
  'shadow-accent': '0 12px 30px rgba(240, 180, 120, 0.35)',
  'shadow-accent-tile': '0 8px 24px rgba(240, 180, 120, 0.4)',
  'shadow-content-lift': '0 -6px 26px #171232',
  'shadow-mascot': 'drop-shadow(0 18px 34px rgba(252, 204, 144, 0.18))',
  // Тёплое свечение вокруг «главного» блока экрана (хиро совместимости, карточка колеса).
  // Смещено вниз намеренно: обе карточки стоят первыми в скролл-контейнере, и всё, что
  // выходит выше его границы, обрезается — работать должны бока и низ.
  'glow-result-card': '0 10px 44px rgba(255, 215, 155, 0.14)',
} as const

/** Размеры, отступы, радиусы. От темы не зависят. */
export const sizeTokens = {
  // Шкала отступов. Имена по группам small/medium/large — так у отступа есть «порядок
  // величины», и на глаз видно, что 4px и 26px не соседи. Значения — из спеки 01 §3
  // (между блоками 10–12, внутри карточек 12–14, внутри тайлов 8–10) плюс запас на края.
  'space-small-xxs': '2px',
  'space-small-xs': '4px',
  'space-small-s': '6px',
  'space-small-m': '8px',
  'space-small-l': '10px',
  'space-medium-xs': '12px',
  'space-medium-s': '14px',
  'space-medium-m': '16px',
  'space-medium-l': '18px',
  'space-large-xs': '22px',
  'space-large-s': '26px',
  'space-large-m': '32px',
  'space-large-l': '40px',

  // Экран
  'screen-padding-x': '14px',
  'screen-padding-top': '24px',
  'screen-width': '390px',
  // Ширина колонки приложения на десктопе — чтобы мобильная раскладка не растягивалась.
  'app-max-width': '500px',
  'screen-radius': '34px',

  // Шторка. Минимум — чтобы короткая шторка (подтверждение, пустой архив) не выезжала
  // полоской в два пальца высотой.
  'sheet-min-height': '300px',

  // Меню-остров
  'menu-height': '64px',
  'menu-inset-x': '14px',
  'menu-inset-bottom': '16px',
  // Резерв под меню-островом больше не константа: он складывается из безопасной зоны и самого
  // острова (`--layout-menu-top` в global.scss). Спечные 92–100px верны только на устройстве
  // без безопасной зоны — на iPhone контент на её высоту уезжал под меню.
  // Резерв под закреплёнными кнопками — тоже: `Screen.Footer` меряет свою высоту сам,
  // а это значение работает лишь до первого замера (кнопок в футере бывает две).
  'reserve-menu-cta': '160px',

  // Радиусы
  'radius-card': '22px',
  'radius-row': '20px',
  'radius-tile': '16px',
  'radius-chip': '14px',
  'radius-menu': '24px',
  'radius-sheet': '28px',
  'radius-button': '16px',
  'radius-sm': '12px',
  'radius-xs': '8px',
  'radius-round': '50%',
  // Капсула: радиус заведомо больше половины высоты элемента, поэтому торцы всегда
  // получаются полукругами независимо от габаритов (дорожка тумблера).
  'radius-pill': '999px',

  // Контролы
  'tap-min': '44px',
  'control-height-s': '44px',
  'control-height-m': '50px',
  'control-height-l': '52px',
  'control-height-xl': '60px',

  // Прочее
  'border-width': '1.5px',
  'stroke-icon': '1.5',
} as const

/** Типографика: роль → параметры. Компоненты берут роль, а не числа. */
export const typographyTokens = {
  DISPLAY: { size: '28px', weight: 700, lineHeight: 1.2, letterSpacing: '-0.025em' },
  H1: { size: '23px', weight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
  H2: { size: '17px', weight: 600, lineHeight: 1.3, letterSpacing: '-0.01em' },
  H3: { size: '15px', weight: 600, lineHeight: 1.35, letterSpacing: '0' },
  BODY: { size: '15px', weight: 500, lineHeight: 1.44, letterSpacing: '0' },
  BODY_L: { size: '16px', weight: 500, lineHeight: 1.44, letterSpacing: '0' },
  BODY_S: { size: '13px', weight: 400, lineHeight: 1.45, letterSpacing: '0' },
  CAPTION: { size: '11.5px', weight: 500, lineHeight: 1.4, letterSpacing: '0' },
  MICRO: { size: '10.5px', weight: 400, lineHeight: 1.4, letterSpacing: '0' },
  OVERLINE: { size: '10px', weight: 600, lineHeight: 1.4, letterSpacing: '0.18em' },
  TAB: { size: '9.5px', weight: 500, lineHeight: 1.2, letterSpacing: '0' },
  HERO_PERCENT: { size: '46px', weight: 700, lineHeight: 1, letterSpacing: '-0.04em' },
} as const

export const motionTokens = {
  'duration-tap': '120ms',
  'duration-fast': '200ms',
  'duration-normal': '300ms',
  'duration-drift': '600ms',
  'duration-hero': '900ms',
  'easing-standard': 'ease',
  'easing-out': 'ease-out',
  'easing-in-out': 'ease-in-out',
} as const

export const zIndexTokens = {
  'z-background': '0',
  'z-content': '1',
  'z-header': '3',
  'z-floating': '9',
  'z-menu': '10',
  'z-overlay': '90',
  'z-sheet': '100',
  'z-modal': '200',
  'z-toast': '300',
} as const

export const fontTokens = {
  'font-family-base': "'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
} as const
